export function boxConsumableValidate(box){
    var result = true;
    
    result = validateStockMin(box.stockMin);
    result = validateStock(box.stock);
    result = validateStockDamaged(box.stockDamaged);
    result = validateStockStolen(box.stockStolen);
    result = validateWarehouseId(box.warehouseId);
    result = validateId(box.consumable.id);
    result = validateName(box.consumable.name);
    result = validateLength(box.consumable.length);
    result = validateWidth(box.consumable.width);
    result = validateHeight(box.consumable.height);
    result = validateVolumetricWeight(box.consumable.volumetricWeight);
    result = validateUnits(box.consumable.units);

    return result;
}

function validateStockMin(stockMin){
    if(!isNaN(stockMin)) return true;
    else return false;
}

function validateStock(stock){
    if(!isNaN(stock)) return true;
    else return false;
}

function validateStockDamaged(stockDamaged){
    if(!isNaN(stockDamaged)) return true;
    else return false;
}

function validateStockStolen(stockStolen){
    if(!isNaN(stockStolen)) return true;
    else return false;
}

function validateWarehouseId(warehouseId){    
    if(Number.isInteger(warehouseId)) return true;
    else return false;
}

function validateId(id){    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateName(name){
    if(typeof name === 'string' && name.trim() !== '') return true;
    else return false;
}

function validateLength(length){
    if(typeof length === 'number' || length == null) return true;
    else return false;
}

function validateWidth(width){
    if(typeof width === 'number' || width == null) return true;
    else return false;
}

function validateHeight(height){
    if(typeof height === 'number' || height == null) return true;
    else return false;
}

function validateVolumetricWeight(volumetricWeight){
    if(typeof volumetricWeight === 'number' || volumetricWeight == null) return true;
    else return false;
}

function validateUnits(units){
    if(typeof units === 'string' && units.trim() !== '') return true;
    else return false;
}